import Repository from './../Repository';

const resource = 'admin/quizzes';

export default {
    get(payload)        {return Repository.get(`${resource}`, payload);},
    getResults(payload)        {return Repository.get(`${resource}/results`, payload);},
    show(id)            {return Repository.get(`${resource}/${id}`);},
    create(payload)     {return Repository.post(`${resource}`, payload);},
    update(payload, id) {return Repository.post(`${resource}/${id}`, payload);},
    delete(id)          {return Repository.delete(`${resource}/${id}`);},
    enableDisable(id)   {return Repository.put(`${resource}/${id}/toggle/status`);},
}